<template>
    <div class="progress-circle"
         :class="{'over50': this.fixedPercent > 50}">
            <span>
            </span>
        <div class="left-half-clipper">
            <div class="first50-bar"
                 :style="colorFillOver50"
            ></div>
            <div class="value-bar"
                 :style="progress"></div>
        </div>

        <span v-show="text" class="text text-sMedium color__charcoal">{{percent}}%</span>
    </div>
</template>

<script>

export default {

    name: 'circular-progress-bar',

    props: {

        percent: {
            type: Number,
            default: 0
        },

        size: {
            type: Number,
            default: 40
        },

        colorEmpty: {
            type: String,
            default: '#C8C8CF'
        },

        colorFill: {
            type: String,
            default: '#00d191'
        },

        text: {
            type: Boolean,
            default: false
        }
    },

    computed: {

        progress() {
            return `transform: rotate(${this.fixedPercent * 3.6}deg);border-color: ${this.colorFill}`
        },

        colorFillOver50() {
            return this.fixedPercent > 50
                ? `background-color: ${this.colorFill};`
                : ''
        },

        fixedPercent() {
            if (this.percent > 99) {
                return 100
            } else if (this.percent < 1) {
                return 0
            } else {
                return this.percent
            }
        }
    }
}
</script>

<style lang="scss" scoped>

.progress-circle {
    font-size: 8px;
    margin: 8px;
    position: relative;
    padding: 0;
    width: 40px;
    height: 40px;
    background-color: $silver;
    border-radius: 50%;
    line-height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;

    .text {
        position: absolute;
        z-index: 1;
    }
}

.progress-circle:after {
    border: none;
    position: absolute;
    top: 4px;
    left: 4px;
    text-align: center;
    display: block;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    content: " ";
    background-color: white;
}

.left-half-clipper {
    border-radius: 50%;
    width: 40px;
    height: 40px;
    position: absolute;
    clip: rect(0, 40px, 40px, 20px);
}

.progress-circle.over50 .left-half-clipper {
    clip: rect(auto, auto, auto, auto);
}

.value-bar {
    position: absolute;
    clip: rect(0, 20px, 40px, 0);
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 4px solid;
    box-sizing: border-box;
}

.progress-circle.over50 .first50-bar {
    position: absolute;
    clip: rect(0, 40px, 40px, 20px);
    border-radius: 50%;
    width: 40px;
    height: 40px;
}

.progress-circle:not(.over50) .first50-bar {
    display: none;
}

.progress-circle.p0 .value-bar {
    display: none;
}
</style>
